import { Popup, Icon, List } from "semantic-ui-react";
import { CheckIcon, WarningIcon } from "../index";

const styles = {
	errorPopup: {},
};

const MotivationsTab = ({ t, disabled, motivationsSaved, motivationsErrors }) => {
	return (
		<Popup
			position="bottom right"
			disabled={motivationsSaved && motivationsErrors.length === 0}
			style={styles.errorPopup}
			offset="7px, 0"
			trigger={
				<span>
					<Icon name="clipboard check" size="small" /> {t("subMenu.motivations")}
					{!disabled && (motivationsSaved && motivationsErrors.length === 0 ? <CheckIcon /> : <WarningIcon />)}
				</span>
			}
		>
			<Popup.Header>{t("subMenu.noMotivations")}</Popup.Header>
			<Popup.Content>
				<List bulleted>
					{!motivationsSaved && <List.Item key={`motivations-not-saved`}>{t("subMenu.motivationNotSaved")}</List.Item>}
					{motivationsErrors.map((error, index) => (
						<List.Item key={`motivation-${index}`}>{error}</List.Item>
					))}
				</List>
			</Popup.Content>
		</Popup>
	);
};

export default MotivationsTab;
